import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { FinanceProgramForm } from 'modules/financeProgram/schema';
import { FinanceCriteriaOptions } from 'modules/financeProgram/types';
import { LenderProfiles } from '@trnsact/trnsact-shared-types/src/generated';

import { ProgramDetails } from '../details/ProgramDetails';
import { ChooseCriteria } from '../criteria/ChooseCriteria';
import { SubmissionSettings } from '../submission/SubmissionSettings';
import { InsuranceCoverageRequirements } from '../insurance/InsuranceCoverageRequirements';

interface Props {
  isReadOnly: boolean;
  isMultipleLenders?: boolean;
  userType?: 'lender' | 'dealer';
  lendersOptions: LenderProfiles[];
  isLendersSelectDisabled?: boolean;
  dealerVendorProfileOptions?: any[];
  criteriaOptions: FinanceCriteriaOptions[];
  lpsWithOcaAccessByLenderProfileId?: Record<string, LenderProfiles>;
}

export const ProgramSettings = ({
  userType,
  isReadOnly,
  lendersOptions,
  criteriaOptions,
  isMultipleLenders,
  isLendersSelectDisabled,
  dealerVendorProfileOptions,
  lpsWithOcaAccessByLenderProfileId = {},
}: Props) => {
  const { control } = useFormContext<FinanceProgramForm>();
  const selectedLenders = useWatch({ control, name: 'program.first.details.lenders' }) as LenderProfiles[];
  const isLenderCreditAppSettingVisible = useMemo(
    () => selectedLenders?.some(l => !!lpsWithOcaAccessByLenderProfileId[l.id!]),
    [selectedLenders]
  );

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
        alignItems: 'start',
      }}
    >
      <ProgramDetails
        userType={userType}
        isReadOnly={isReadOnly}
        lendersOptions={lendersOptions}
        isMultipleLenders={isMultipleLenders}
        isLendersSelectDisabled={isLendersSelectDisabled}
        dealerVendorProfileOptions={dealerVendorProfileOptions}
        isLenderCreditAppSettingVisible={isLenderCreditAppSettingVisible}
      />
      <ChooseCriteria
        isReadOnly={isReadOnly}
        userType={userType}
        criteriaOptions={criteriaOptions}
        dealerVendorProfileOptions={dealerVendorProfileOptions}
      />
      <InsuranceCoverageRequirements isReadOnly={isReadOnly} />
      <SubmissionSettings isReadOnly={isReadOnly} />
    </Box>
  );
};
